import { waitForAppMeasurement } from "../waitForAppMeasurement"

export const trackLink = (href: string, linkType: "link" | "download" = "link") => {
	const [cleanHref] = href.split("?")

	waitForAppMeasurement((s) => {
		// https://experienceleague.adobe.com/en/docs/analytics/implementation/vars/functions/tl-method#stl-method-in-appmeasurement-and-the-analytics-extension-custom-code-editor
		// o = custom link, d = download link, e = exit link
		s.tl(true, linkType === "download" ? "d" : "e", cleanHref)
	})
}
